module.exports = __webpack_public_path__ + "img/title1.7d9a43e1.png";